import React from 'react';

interface GradientLogoProps {
  size?: 'small' | 'medium' | 'large';
}

const GradientLogo: React.FC<GradientLogoProps> = ({ size = 'medium' }) => {
  const sizeClasses = {
    small: 'text-xl',
    medium: 'text-2xl',
    large: 'text-3xl'
  };

  return (
    <div className={`font-bold ${sizeClasses[size]} inline-block`}>
      <span className="bg-gradient-to-r from-[#f2055c] via-[#d91438] to-[#8c1616] bg-clip-text text-transparent">
        Java Dev Week
      </span>
    </div>
  );
};

export default GradientLogo;